import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '../../locales';
import SvgIcon from '../common/base/SvgIcon.vue';
import LoadingScheduleIcon from '../common/icons/LoadingScheduleIcon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingOverlay',
  setup(__props) {

const { t } = useI18n();

return { __sfc: true,t, SvgIcon, LoadingScheduleIcon }
}

})